import { useQuery } from 'react-query';

import { getWidgetColumnsByID as queryFn } from 'api/endPoints/getWidgetColumnsByID';

interface QueryFnResponse {
    columns: string;
    widgetId: number;
}

interface QueryResponse {
    columnOrder: string[];
    hiddenColumns: string[];
}

export interface QueryParams {
    widgetId: string | undefined;
    enabled: boolean;
}

export const useQueryGetWidgetColumns = (params: QueryParams) => {
    return useQuery<QueryFnResponse | null, QueryError, QueryResponse>(
        ['getWidgetColumns', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.widgetId) && params.enabled,
            select: (response) => {
                return response?.columns ? JSON.parse(response.columns) : null;
            },
        },
    );
};
